import React from 'react';
import { Grid, TextField } from '@mui/material';
import { Params } from '../interfaces';
import { transformParamsToArray } from './interfaces';

interface Props {
  params: Params;
}

const ProcessView = ({ params }: Props) => (
  <Grid container>
    {transformParamsToArray(params).map((value, index) => (
      <Grid item xs={12} key={index} style={{ display: 'flex' }}>
        <Grid item xs={12} mb={3}>
          <TextField disabled fullWidth id="outlined-disabled" label={`${value.key}`} defaultValue={value.value} />
        </Grid>
      </Grid>
    ))}
  </Grid>
);

export default ProcessView;
